<script>
import Base from "@/components/RequestDetails/RequestAttachments.vue";

export default {
  name: "DefaultViewRequestAttachments",
  extends: Base,
};
</script>

